<div #container class="d-none">
  <form #form="ngForm">
    <ng-content></ng-content>
    <input type="submit" class="d-none" #submitButton>
  </form>
</div>
